import { render, staticRenderFns } from "./DashboardGas.vue?vue&type=template&id=270a7f07&scoped=true&"
import script from "./DashboardGas.vue?vue&type=script&lang=js&"
export * from "./DashboardGas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGas.vue?vue&type=style&index=0&id=270a7f07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a7f07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
